import soft from "../../../assets/Tyres/Soft.png";
import medium from "../../../assets/Tyres/Midium.png";
import hard from "../../../assets/Tyres/Hard.png";
import intermediate from "../../../assets/Tyres/Intermediate.png";
import wet from "../../../assets/Tyres/Wet.png";

export const tyreImages = {
  Soft: soft,
  Medium: medium,
  Hard: hard,
  Inter: intermediate,
  Wet: wet,
};
